module.exports = __webpack_public_path__ + "public/img/subscription-bg-1-dd77f35f.jpg";